export default "__VITE_ASSET__B90Xw6n1__"